module.exports = __webpack_public_path__ + "static/media/info-outlined-icon.1fb600f0.svg";